import React, { useState, useEffect } from 'react';
import clientSvg from "/src/assets/img/svg/client.svg"
import { useForm } from 'react-hook-form';
import datasetService from '/src/features/dataset/services/datasetService';
import integrationService from '../../services/integrationService';
import Form from '/src/components/form/Form';
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import languages from '/src/data/dropdown/languages';
import Button from "/src/components/UI/Button/Button";
import DropDown from '/src/components/UI/DropDown/DropDown';
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import IconButton from "/src/components/UI/Button/IconButton/IconButton"
import "./IntegrationForm.css"
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import { useNavigate } from "react-router-dom";
import IntegrationTypes from '../../data/types/IntegrationTypes';
import storage from '/src/utils/storage';
import generateKey from '/src/utils/generateKey';
function IntegrationForm({ data, type }) {

	const [listDatasets, setListDatasets] = useState("");
	const [listCheckedDataset, setListCheckedDataset] = useState([])
	const { getDatasetsIvy, getDatasetsWorksheet } = datasetService;
	const { addIntegration } = integrationService;

	const navigate = useNavigate();
	const currentCompany = storage("session").get("company")
	const { register, handleSubmit, getValues, setValue, watch, formState: { errors }, formState } = useForm({
		mode: "onChange",
		defaultValues: {
			name: "",
			datasets: [],
			language: "fr",
			active: true,
			integration_type_id : 1
		}
	});

	const setUpDataset = async (type) => {
		var res = [];
		var [res, error] = (type == 3 || type == 4) ? await getDatasetsWorksheet({ public: true }) : await getDatasetsIvy({ public: true })
		if (error != null){
			console.error(error);
			return;
		}
		setListDatasets(res);
	}
	const setType = async (type) => {
		setUpDataset(type);
		setValue("integration_type_id", type);
	}
	useEffect(() => {
		setUpDataset(0);
	}, [])

	const checkDataset = (_faq) => {
		let result = listCheckedDataset;
		if (result.filter((dataset) => { return dataset.id == _faq.id; }).length == 0) { // if dataset is not checked
			result.push(_faq);
			setListCheckedDataset(result)

			document.getElementById(_faq.id + "button").style.color = "var(--green)"
			document.getElementById(_faq.id + "button").children[0].classList = "fas fa-check-circle"

		}
		else { // if dataset is already checked
			let index = listCheckedDataset.findIndex(dataset => dataset.id === _faq.id);
			result.splice(index, 1)
			setListCheckedDataset(result)

			document.getElementById(_faq.id + "button").style.color = "var(--main)"
			document.getElementById(_faq.id + "button").children[0].classList = "fas fa-plus-circle"
		}
		checkForm();
	}

	const checkForm = () => {
		document.getElementById("submit_integration_form").disabled = !(getValues("name").length >= 3 && listCheckedDataset.length > 0);

	}
	const onSubmit = async () => {
		setValue("datasets", listCheckedDataset);

		var dataToSend = getValues();
		let [response, error] = await addIntegration(dataToSend)
		if (error !== null) {
			console.log(error);
			return;
		}
		return navigate(urlWithRoutingCompany('/plugin/integrations/list'));

	};

	return (
		<Form onSubmit={handleSubmit(onSubmit)}>
			<Form.Title>Create a new Api 🔑</Form.Title>
			<Form.Body>
				<div className="botForm-container">
					<Field label="Name of your Integration" listLabelClassName="titles-input">
						<TextInput {...register('name', { required: true, minLength: 3, onChange: () => checkForm() })} style={errors.name ? { borderColor: "red" } : {}} />
						<span className='error'>{errors.name ? "At least 3 letters" : ""}</span>
					</Field>
				</div>
				<div className="container_integration_dropdown">
					<Field label="Select your language" listLabelClassName="titles-input"></Field>
					<div style={{ marginLeft: "15%", marginTop: "2%" }}>
						<DropDown {...register('language')} setValue={setValue} choices={languages} defaultChoice="fr" width="181px"></DropDown>
					</div>
				</div>
				<br/>
				<div className='container_integration_dropdown'>
					<Field label="Type Integration" listLabelClassName="titles-input"></Field>
					<div style={{ marginLeft: "15%", marginTop: "2%" }}>
						<DropDown {...register('integration_type_id')} setValue={(name,value)=>setType(value)} choices={IntegrationTypes} defaultChoice="1" width="181px"></DropDown>
					</div>
				</div>
				<div className="botForm-container">
					<Field label="Select some datasets" listLabelClassName="titles-input">
					</Field>
				</div>
				{Array.isArray(listDatasets) ?
					<div className="dataset-list">
						{listDatasets.map((dataset, i) => {
							let isShared = dataset.company.id != currentCompany.id;
							return (
								<div className="dataset-block" data-checked="false" data-id={dataset.id} key={generateKey()}>
									<div className='container_dataset_row'>
										<img style={{width : isShared ? "30px" : "20px" }}src={isShared?  dataset.company.logo : clientSvg}></img>
										<div className="integration_title_dataset" title={dataset.name}>{dataset.name} </div>
									</div>
									<div>
										<IconButton id={dataset.id + "button"} className="main-iconButton add-hover modalButtons-input" icon="fas fa-plus-circle" onClick={(e) => checkDataset(dataset)} />

									</div>
								</div>
							)
						})}
					</div>
					:
					null
				}
			</Form.Body>
			<br /><br />
			<Form.Buttons>
				<Button id="submit_integration_form" type="submit" label={"Validate"} className="validate" disabled={true} />
			</Form.Buttons>
		</Form >
	)

}

export default IntegrationForm;